import { GraphicsUtil } from '@suntex.core/animation';
import { $Color, Color } from '@suntex.core/color';

export const STEM_WIDTH = 4;

export class Stem extends createjs.Container {
  constructor(length: number, color: Color) {
    super();
    const stem = GraphicsUtil.createSprite((g) => {
      g.beginFill(
        $Color.toHexString($Color.getGradientColor(color, 'highlight')),
      );
      g.drawRect(0, -STEM_WIDTH / 2, -length, STEM_WIDTH);
    });
    this.addChild(stem);
  }
}
